import {
  Button,
  DatePicker,
  Form,
  InputNumber,
  Modal,
  Select,
  Space,
} from 'antd';
import React from 'react';

import { DUMMY_TICKET_CATEGORY_OPTIONS } from '../../../../constants';
import type { TicketDistributionData } from '../../types';
import { MEMBER_OPTIONS, PLAN_OPTIONS } from './constants';
import { generateInitialFormValues } from './helpers';
import styles from './index.module.scss';

type AddOrEditModalProps = {
  showModal: boolean;
  closeModal: () => void;
  ticketDistributionData: TicketDistributionData | undefined;
};

const { Item } = Form;

export const AddOrEditModal = ({
  showModal,
  closeModal,
  ticketDistributionData,
}: AddOrEditModalProps) => {
  const onFormFinish = (formValues: TicketDistributionData) => {
    console.log('formValues:\n', formValues);
  };

  const initialFormValues = generateInitialFormValues(ticketDistributionData);

  return (
    <Modal
      open={showModal}
      onCancel={closeModal}
      centered
      destroyOnClose
      maskClosable={false}
      title={
        <h4 className={styles['mb-0']}>{`${
          ticketDistributionData ? '編輯' : '新增'
        }票券發放`}</h4>
      }
      footer={null}
    >
      <Form
        layout="vertical"
        onFinish={onFormFinish}
        initialValues={initialFormValues}
      >
        <Item label="發放票券" name="ticketName" rules={[{ required: true }]}>
          <Select
            placeholder="請選擇票券類別"
            // TODO: 假的options，記得替換成真的
            options={DUMMY_TICKET_CATEGORY_OPTIONS}
          />
        </Item>
        <Item label="發放對象" required>
          <Space
            direction="vertical"
            className={styles.recipientsFieldContainer}
          >
            <div className={styles.recipientsField}>
              <p>方案對象：</p>
              <Item name={['recipients', 'plans']} noStyle>
                {/* TODO: 這邊暫時用Select，但最後資料格式要怎樣，需要再討論，再看是要用Select或是Cascader */}
                <Select
                  allowClear
                  showArrow
                  mode="multiple"
                  maxTagCount="responsive"
                  placeholder="請選擇方案對象"
                  // TODO: 假資料，要改成真實資料
                  options={PLAN_OPTIONS}
                />
              </Item>
            </div>
            <div className={styles.recipientsField}>
              <p>會員對象：</p>
              <Item name={['recipients', 'members']} noStyle>
                <Select
                  allowClear
                  mode="multiple"
                  maxTagCount="responsive"
                  placeholder="搜尋會員對象"
                  // TODO: 假資料，要改成真實資料，這邊的options，會是用戶搜尋的同時去打API獲取符合條件的會員資料列表
                  options={MEMBER_OPTIONS}
                />
              </Item>
            </div>
          </Space>
        </Item>
        <Item label="票券發放日" name="issueDate" rules={[{ required: true }]}>
          <DatePicker className={styles.issueDatePicker} />
        </Item>
        <div className={styles.validPeriod}>
          <Item
            label="票券使用起始日"
            name="startDate"
            className={styles['flex-1']}
            rules={[{ required: true }]}
          >
            <DatePicker className={styles['w-full']} />
          </Item>
          <Item
            label="票券使用結束日"
            name="endDate"
            className={styles['flex-1']}
            rules={[{ required: true }]}
          >
            <DatePicker className={styles['w-full']} />
          </Item>
        </div>
        <Item label="發放張數" name="amount" rules={[{ required: true }]}>
          <InputNumber
            min={1}
            step={1}
            placeholder="例如：1（不需輸入單位）"
            className={styles['w-full']}
          />
        </Item>
        <Item className={styles.formActionButtons}>
          <Button
            className={styles.submitButton}
            type="primary"
            htmlType="submit"
          >
            確認
          </Button>
          <Button onClick={closeModal}>取消</Button>
        </Item>
      </Form>
    </Modal>
  );
};
